import { useState } from 'react';
import { Button, Input } from '@accure/ui';
import { Plus, X } from 'lucide-react';

import { useMe } from '@/hooks/use-me';

export type InputRecipientsProps = {
  value: string[];
  onChange: (value: string[]) => void;
  hasLoadedData: boolean;
};

export function InputRecipients({
  value,
  onChange,
  hasLoadedData,
}: InputRecipientsProps) {
  const [newEmail, setNewEmail] = useState('');
  const me = useMe();

  function handleAddEmail() {
    const email = newEmail.trim();
    if (!email) {
      return;
    }

    if (email && !value.includes(email)) {
      setNewEmail('');
      onChange([...value, email]);
    }
  }

  function handleRemoveEmail(email: string) {
    onChange(value.filter((e) => e !== email));
  }

  return (
    <div className="space-y-2">
      <div className="space-y-2">
        {hasLoadedData ? null : (
          <div className="flex items-center justify-between rounded-md border">
            <span className="m-2 text-sm text-neutral-600">{me.email}</span>
            <span className="m-2 text-xs text-neutral-500">
              Can be removed later
            </span>
          </div>
        )}
        {value.map((email: string) => (
          <div
            key={email}
            className="flex items-center justify-between rounded-md border last:mb-2"
          >
            <span className="m-2 text-sm">{email}</span>
            <Button
              type="button"
              variant="ghost"
              onClick={() => handleRemoveEmail(email)}
            >
              <X className="size-4" />
            </Button>
          </div>
        ))}
      </div>

      <div className="flex gap-2">
        <Input
          className="flex-1"
          placeholder="Enter email address"
          value={newEmail}
          onChange={(e) => setNewEmail(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleAddEmail();
            }
          }}
        />
        <Button
          type="button"
          variant="outline"
          className="flex items-center gap-1"
          onClick={handleAddEmail}
        >
          <Plus className="size-4" />
          <span>Add Email</span>
        </Button>
      </div>
    </div>
  );
}
